// extracted by mini-css-extract-plugin
module.exports = {"tos":"style-module__tos___2w7ul"};